export default __webpack_public_path__ + "static/media/Vambrace of Red Ruin.18035828.jpg";